import React from 'react';
import { useAuth } from '@/providers/AuthProvider';
import { MessageBubble } from './message-bubble';
import { MessageCircle } from 'lucide-react';
import { AnimatePresence, motion } from 'framer-motion';

interface MessageListProps {
  messages: any[];
  onReply?: (message: any) => void;
  onDelete?: (messageId: string) => void;
  onEdit?: (message: any) => void;
  onForward?: (message: any) => void;
}

export function MessageList({ messages, onReply, onDelete, onEdit, onForward }: MessageListProps) {
  const { user } = useAuth();

  if (!messages.length) {
    return (
      <div className="flex flex-col items-center justify-center h-full text-center py-16">
        <div className="w-20 h-20 bg-gradient-to-br from-blue-100 to-indigo-100 rounded-full flex items-center justify-center mb-6">
          <MessageCircle className="w-10 h-10 text-blue-500" />
        </div>
        <h3 className="text-lg font-semibold text-gray-700 mb-2">No messages yet</h3>
        <p className="text-gray-500 text-sm">Start the conversation by sending a message</p>
      </div>
    );
  }

  return (
    <div className="space-y-2">
      <AnimatePresence initial={false} mode="popLayout">
        {messages.map((message) => {
          const isSender = message.senderId === user?.uid;

          return (
            <motion.div
              key={message.id}
              layout
              initial={{ opacity: 0, y: 10, scale: 0.985 }}
              animate={{ opacity: 1, y: 0, scale: 1 }}
              exit={{ opacity: 0, scale: 0.92, y: -8, filter: 'blur(6px)' }}
              transition={{ duration: 0.22, ease: 'easeOut' }}
            >
              <MessageBubble
                message={message}
                isSender={isSender}
                onReply={onReply}
                onDelete={onDelete}
                onEdit={onEdit}
                onForward={onForward}
              />
            </motion.div>
          );
        })}
      </AnimatePresence>
    </div>
  );
}